import clsx from 'clsx';
import { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ZERO } from '@/constants';
import { useCurrentUser } from '@/hooks';

import GetStartedNav from '@/components/GetStarted/Navigation';
import { GetStartedContext } from '@/components/GetStarted/context';
import LoadingCover from '@/components/Layouts/Loading';

// Steps in order
const STEPS = [
  'about',
  'membership-select',
  'membership-paid',
  'onboarding-video',
  'matching-form',
  'onboarding-complete',
];

const Templates = () => {
  const { user, isUserLoading } = useCurrentUser();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(ZERO);

  useEffect(() => {
    const subPath = pathname.replace('/get-started/', '');
    const index = STEPS.indexOf(subPath);

    setCurrentStep(index >= ZERO ? index : ZERO);
  }, [pathname]);

  const nextStep = (skip = 1, shouldReplace = false) => {
    let nextPath = STEPS[currentStep + skip] ?? '/m';

    if (
      nextPath === 'membership-select' &&
      (user.isPaid || user.isBusinessPaid)
    ) {
      nextPath = 'onboarding-video';
    }

    navigate(nextPath, { replace: shouldReplace });
  };

  // TODO: This is hokey and should be fixed. See discussion in
  // https://team-mento.slack.com/archives/C040B4R9KH8/p1739468550943789
  const context = useMemo(
    () => ({
      currentStep,
      nextStep,
    }),
    // we don't need to update when nextStep is redefined, because all the
    // variables in the closure will trigger an update
    [currentStep, isUserLoading],
  );

  const isMembershipSelect = pathname.startsWith(
    '/get-started/membership-select',
  );

  // Checking for userId to avoid flickers on refetch
  // TODO: Remove once we have fixed the issue with refetch on focus
  if (isUserLoading && !user.id) return <LoadingCover />;

  return (
    <main
      className={clsx('flex h-screen flex-1 flex-col overflow-auto', {
        'bg-sunny-100': !isMembershipSelect,
        'bg-sunny-200': isMembershipSelect,
      })}
    >
      <GetStartedContext.Provider value={context}>
        <GetStartedNav />
        <Outlet />
      </GetStartedContext.Provider>
    </main>
  );
};

export default Templates;
